import axios from 'axios'

export const getCommentsUrl = (contactId, evalId) => `/api/rest/recording/contact/${contactId}/eval/${evalId}/comment`

export default {
  async getComments(contactId, evalId) {
    const url = getCommentsUrl(contactId, evalId)
    try {
      const response = await axios.get(url)

      return response.data
    } catch (error) {
      throw new Error(error)
    }
  },
}
